import Avatar from 'components/ui/Avatar';

import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function BotCard(bot) {
  const { enabled } = bot;
  const history = useHistory();
  const { t } = useTranslation();

  const handleClick = () => {
    history.push(`marketplace/${bot.id}`);
  };

  const category = bot.category || {};
  const transparentBackground = enabled ? '' : 'card-bg-white-transparent';

  return (
    <div className={`card border-0 shadow-sm clickable ${transparentBackground}`}>
      <div className="card-body text-center">
        <div onClick={handleClick}>
          <Avatar name={bot.name} src={bot.profile_image} size={100} className="shadow rounded-circle mb-3" />

          <h5 className="fw-normal mt-0 mb-0 text-truncate">{bot.name}</h5>
          <p className="text-truncate">{bot.description}</p>
          <p className="text-muted">{category.name || t('bots.categories.none')}</p>
        </div>
      </div>
    </div>
  );
}

export default BotCard;
